export default __webpack_public_path__ + "static/media/879.f359eb1d.gif";